/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCarpenterIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-carpenter"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M15.93 21.3Q15.53 21.7 15.05 21.89Q14.57 22.07 14.07 22.07Q13.57 22.07 13.09 21.89Q12.6 21.7 12.2 21.3L11.22 20.32Q10.95 20.05 10.75 19.63Q10.55 19.2 10.5 18.75Q10.45 18.3 10.51 17.85Q10.57 17.4 10.85 17.05L10.85 17.05L2.67 5.38L7 1.05L19.73 13.78Q20.13 14.18 20.31 14.65Q20.5 15.13 20.5 15.63Q20.5 16.13 20.31 16.61Q20.13 17.1 19.73 17.5ZM14.07 19.4Q14.07 19.4 14.07 19.4Q14.07 19.4 14.07 19.4L17.85 15.65Q17.85 15.65 17.85 15.65Q17.85 15.65 17.85 15.65L16.93 14.72L13.13 18.5Q13.13 18.5 13.13 18.5Q13.13 18.5 13.13 18.5Z" fill={color} />
    </svg>
  );
}
